export default __webpack_public_path__ + "static/media/c3.86b1a14d.jpg";